import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Image, Badge, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import WorkforceValidation from "../../../hooks/WorkforceValidation";
import { createUpdateWorkForce } from "../../../store/actions/workForcesAction";
import { fetchLocationList } from "../../../store/actions/locationsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";


const formElements = [
  {
    key: "ward",
    label: "Virtual Ward",
    placeHolder: "Enter ward name",
    type: "text",
  },
  // {
  //   key: "location",
  //   label: "Select Geography",
  //   placeHolder: "Select geography",
  //   type: "select",
  //   options: ["MID (Provide)", "South West (NELFT)", "South East (EPUT)"],
  // },
  {
    key: "workforceCapacity",
    label: "Workforce Capacity",
    placeHolder: "Select workforce capacity",
    type: "select",
    options: ["4", "3", "2", "1"],
  },
  {
    key: "numberOfStaffOnCovidRelatedAbsence",
    label: "No. of staff on COVID related absence?",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "numberOfEnrichedStaff",
    label: "No. of inreach staff (in acutes pulling into community)",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "issueAffecting",
    label: "Issues affecting flow and actions/source of admissions yesterday",
    placeHolder: "Type Here",
    type: "textarea",
  },
];

const ManageWorkForce = (props) => {
  const { selectWorkforce, location } = props;
  console.log("selectWorkforce", selectWorkforce);
  console.log("wardID", selectWorkforce?.ward?._id);
  const [isShow, setIsShow] = useState(false);
  const [isCheckValidation, setIsCheckValidation] = useState(false);
  const [isShowConfirmation, invokeModal] = React.useState(false);
  const initModal = () => {
    invokeModal(false);
    // setLocationworkforceDetail(null);
    hideHandler();
    
  };
  const [localwardId, setLocalWardId] = useState(null);
  const [locationworkforceDetail, setLocationworkforceDetail] = useState(null);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const inputRef = useRef();
  const [locationOptions, setLocationOptions] = useState(null);
  const [workforceDetail, setWorkforceDetail] = useState({
    workforceCapacity: null,
    numberOfStaffOnCovidRelatedAbsence: null,
    numberOfEnrichedStaff: null,
    issueAffecting: null,
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    WorkforceValidation({
      workforceCapacity: workforceDetail?.workforceCapacity,
      numberOfEnrichedStaff: workforceDetail?.numberOfEnrichedStaff
        ? workforceDetail?.numberOfEnrichedStaff.toString()
        : "0",
      numberOfStaffOnCovidRelatedAbsence:
        workforceDetail?.numberOfStaffOnCovidRelatedAbsence
          ? workforceDetail?.numberOfStaffOnCovidRelatedAbsence.toString()
          : "0",
      issueAffecting: workforceDetail?.issueAffecting,
    });
  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector(
    (state) => state.workForces
  );
  const { locations } = useSelector((state) => {
    return state.locations;
  });

  useEffect(() => {
    if (!Array.isArray(locations)) {
      dispatch(fetchLocationList());
    }
  }, []);
  console.log("geography", locations);
  useEffect(() => {
    if (Array.isArray(locations)) {
      let arr = locations.map((x) => x.name);
      setLocationOptions(arr);
    }
  }, [locations]);

  useEffect(() => {
    if (selectWorkforce === null) {
      setWorkforceDetail({
        location: location,
        workforceCapacity: null,
        numberOfStaffOnCovidRelatedAbsence: null,
        numberOfEnrichedStaff: null,
        issueAffecting: null,
      });
    } else {
      setWorkforceDetail({
        workforceId: selectWorkforce?._id,
        ward: selectWorkforce?.ward?.name,
        location: selectWorkforce?.location,
        workforceCapacity: selectWorkforce?.workforceCapacity,
        numberOfEnrichedStaff: selectWorkforce?.numberOfEnrichedStaff,
        numberOfStaffOnCovidRelatedAbsence:
          selectWorkforce?.numberOfStaffOnCovidRelatedAbsence,
        issueAffecting: selectWorkforce?.issueAffecting,
      });
    }
  }, [selectWorkforce, location]);

  const submitHandler = (e) => {
    console.log("workforce", workforceDetail);
    
    e.preventDefault();
    setLocationworkforceDetail(workforceDetail);
    setLocalWardId(selectWorkforce?.ward?._id);
    checkValidator();
   setIsCheckValidation(true)
 
  };
  useEffect(() => {
    if (!isError() && error !== null && isCheckValidation) {
      props.onHide();
      invokeModal(true);
    }
    console.log("error-", error);
    setIsCheckValidation(false);
   
  }, [isCheckValidation]);

  const updateWorkforce = () => {
    console.log("setLocalWardId", localwardId);
    console.log("locationworkforceDetail", locationworkforceDetail);
    setIsActionCalled(true);
    invokeModal(false);
  };
  useEffect(() => {
    let formData = {
      ward: localwardId,
      workforceCapacity: locationworkforceDetail?.workforceCapacity,
      numberOfEnrichedStaff: locationworkforceDetail?.numberOfEnrichedStaff,
      numberOfStaffOnCovidRelatedAbsence:
        locationworkforceDetail?.numberOfStaffOnCovidRelatedAbsence,
      issueAffecting: locationworkforceDetail?.issueAffecting,
    };
    console.log("formData-", formData);

    if (!isError() && error !== null && isActionCalled) {
      dispatch(createUpdateWorkForce(formData)).then(({ payload }) => {
        console.log("payload-", payload);
        if (payload.success) {
          hideHandler();
          setLocationworkforceDetail(null);
        } else {
          setIsShow(true);
        }
      });
      setIsActionCalled(false);
    }
    console.log("error-", error);
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandler = () => {
    resetAllValidator();
    props.onHide();

    if (selectWorkforce === null) {
      setWorkforceDetail({
        location: location,
        workforceCapacity: null,
        numberOfStaffOnCovidRelatedAbsence: null,
        numberOfEnrichedStaff: null,
        issueAffecting: null,
      });
    } else {
      setWorkforceDetail({
        workforceId: selectWorkforce?._id,
        ward: selectWorkforce?.ward?.name,
        location: selectWorkforce?.location,
        workforceCapacity: selectWorkforce?.workforceCapacity,
        numberOfEnrichedStaff: selectWorkforce?.numberOfEnrichedStaff,
        numberOfStaffOnCovidRelatedAbsence:
          selectWorkforce?.numberOfStaffOnCovidRelatedAbsence,
        issueAffecting: selectWorkforce?.issueAffecting,
      });
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const upload = (e) => {
    console.log(e.target.files[0]);
  };

  const { onHide, ...props1 } = props;

  return (
    <>
      <Popup
        className=""
        {...props1}
        onHide={hideHandler}
        size="md"
        footer={
          <>
            <Button
              variant="outline-secondary "
              className="model-btn me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectWorkforce ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}

        {formElements.map((element, i) => {
          return (
            (!selectWorkforce || element.key !== "password") && (
              <Form.Group className="mb-4" controlId="formBasicEmail" key={i}>
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                {element.type == "select" ? (
                  <>
                    <Form.Select
                      name={element.key}
                      disabled={location && element.key == "location"}
                      value={workforceDetail && workforceDetail[element.key]}
                      onChange={(e) => {
                        console.log("selected");
                        setWorkforceDetail({
                          ...workforceDetail,
                          [element.key]: e.target.value,
                        });
                        resetValidator(e.target.name);
                      }}
                      isInvalid={error && error[element.key]}
                    >
                      <option style={{ display: "none" }} value="">
                        Select
                      </option>
                      {element.key == "location" && locationOptions
                        ? locationOptions.map((item) => (
                            <option value={item}>{item}</option>
                          ))
                        : element.options.map((item) => (
                            <option value={item}> {item} </option>
                          ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                  </>
                ) : (
                  <>
                    <Form.Control
                      type={element.type}
                      name={element.key}
                      placeholder={element.placeHolder}
                      value={workforceDetail && workforceDetail[element.key]}
                      disabled={workforceDetail && element.key === "ward"}
                      onChange={async (e) => {
                        setWorkforceDetail({
                          ...workforceDetail,
                          [element.key]: e.target.value,
                        });
                        resetValidator(e.target.name);

                        console.log("workforceDetail", workforceDetail);
                      }}
                      isInvalid={error && error[element.key]}
                    />

                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                  </>
                )}
              </Form.Group>
            )
          );
        })}

        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordUpdated: isShow,
            title: "Manage Client",
            successMsg: successMessage,
            errorRes: apiError?.message,
          }}
        />
      </Popup>
      {/* Comformation box */}

      <Modal
        
        backdrop="static"
        keyboard={false}
        className=" me-2 shadow-lg foo-modal-backdrop"
        size="md"
        show={isShowConfirmation}
        centered
      >
        <Modal.Header closeButton onClick={initModal}>
          <Modal.Title
            style={{
              display: "inline-block",
              marginLeft: "42%",
              fontWeight: "700",
            }}
          >
            Alert
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          Are you sure you want to update workforce ?
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          <Button
            variant="outline-secondary "
            className="me-4 px-4"
            onClick={initModal}
          >
            No
          </Button>
          <Button className="btn-primary px-4" onClick={updateWorkforce}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ManageWorkForce;
